import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  SELECT_RIGHT_OPTIONS_ITEM: `${NAMESPACE}_HEADER_SELECT_RIGHT_OPTIONS_ITEM`
};

export const actionCreators = {
  selectRightOptionsItem: (menu, { force = false } = {}) => ({
    type: actions.SELECT_RIGHT_OPTIONS_ITEM,
    payload: { menu, force }
  })
};

export default {
  actions,
  actionCreators
};
